export function PageContainer(props: React.PropsWithChildren) {
  return <div className="">{props.children}</div>;
}
